export const OBJFileLoaderMetadata = {
    name: "obj",
    extensions: ".obj",
};
//# sourceMappingURL=objFileLoader.metadata.js.map